import { collection, getDocs, addDoc, setDoc, doc, query, where, deleteDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';

const SERVICES = [
  { name: 'Gentleman Cut', price: 75000, duration: 45 },
  { name: 'Premium Fade', price: 100000, duration: 60 },
  { name: 'Beard Trim & Shave', price: 50000, duration: 30 },
  { name: 'Hair Color (Basic)', price: 150000, duration: 90 },
  { name: 'Hair Spa & Massage', price: 60000, duration: 40 },
];

export const seedDatabase = async () => {
  try {
    // Check if services exist
    try {
      const sSnap = await getDocs(collection(db, 'services'));
      if (sSnap.empty) {
        console.log('Seeding services...');
        for (const s of SERVICES) {
          try {
            await addDoc(collection(db, 'services'), s);
          } catch (err: any) {
            if (err.code === 'permission-denied' || err.message?.includes('permission')) {
              console.log('Skipped seeding services due to missing permissions.');
            } else {
              throw err;
            }
          }
        }
      }
    } catch (err: any) {
      if (err.code === 'permission-denied' || err.message?.includes('permission')) {
        console.log('Skipped fetching/seeding services due to missing permissions.');
      } else {
        throw err;
      }
    }

    // Permanently clean up/delete dummy seed barbers (Cindy Lestari and Andra Wijaya)
    const dummyIds = ['barber_seed_1', 'barber_seed_2'];
    for (const dId of dummyIds) {
      try {
        await deleteDoc(doc(db, 'users', dId));
        console.log(`Successfully performed cleanup for dummy barber: ${dId}`);
      } catch (err: any) {
        console.log(`Silently skipped deleting dummy barber ${dId}: ${err.message}`);
      }
    }

    return true;
  } catch (e) {
    console.error('Seed failed:', e);
    return false;
  }
};
